function initInputsWithMaxLength(){
    document.querySelectorAll('[maxlength]').forEach( input => {
            const maxlength = Number(input.getAttribute('maxlength'));
            const errorMsg = document.createElement('p');
            errorMsg.setAttribute('hidden', '');
            errorMsg.classList.add('input-error');
            errorMsg.innerHTML = `This field is limited to ${maxlength} characters`;
            input.parentElement.appendChild(errorMsg);
            input.addEventListener('keyup', e => {
                console.log('change happened');
                if (input.value.length >= maxlength){
                    console.log('reached maxlength');
                    console.log(errorMsg);
                    errorMsg.removeAttribute('hidden');
                    return false;
                } else {
                    errorMsg.setAttribute('hidden', '');
                }
            });
        });
}

export default initInputsWithMaxLength;
